/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useMemo, useEffect } from 'react'
import { useIntl } from 'react-intl';
import { Resizable } from 're-resizable'
import { useLang } from '../../../../_metronic/i18n/Metronici18n';
import { MenuComponent } from '../../../../_metronic/assets/ts/components';
import { KTSVG } from '../../../../_metronic/helpers';
import NoDatas from '../../../components/NoDatas';
import Pagenation from '../../../components/pagination/Pagenation';
import TabTableItem2 from '../../../components/TabTableItem2';
import { shallowEqual, useSelector } from 'react-redux';
import { RootState } from '../../../../setup';
import { alphabetically } from '../../../../setup/utils/utils';
var XMLParser = require('react-xml-parser');

const TestJournalModal = (props: any) => {
    const { id, options = [], closeModal } = props;

    const handleClose = () => {
        closeModal();
    }
    const [totalData, setTotalData] = useState<any[]>([]);
    const [columns, setColumns] = useState<any[]>([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalColumnItems, setTotalColumnItems] = useState<any[]>(totalData);
    const [columnItems, setColumnItems] = useState<any[]>([]);
    const [sortAsc, setSortASC] = useState<any>();
    const [currentsort, setCurrentSort] = useState<string>("testdate");
    const [sortFlag, setSortFlag] = useState<boolean>(true);
    const [columnWidthsObj, setColumnWidthsObj] = useState<any>({});
    let minColumnWidthsObj: any = {};

    const lang = useLang()
    const intl = useIntl()

    const columnValues: any = useSelector<RootState>(({ customer }) => customer.testJournalColumnValues, shallowEqual) as any;
    const definitions: any = useSelector<RootState>(({ customer }) => customer.testJournalDefinitions, shallowEqual) as any;
    const columnList: any = useSelector<RootState>(({ customer }) => customer.testJournalColumnList, shallowEqual) as any;
    const en: any = useSelector<RootState>(({ customer }) => customer.testJournalEn, shallowEqual) as any;
    const de: any = useSelector<RootState>(({ customer }) => customer.testJournalDe, shallowEqual) as any;

    useEffect(() => {
        if (columnValues) {
            setTotalData(columnValues);
        }
    }, [columnValues])

    useEffect(() => {
        let translateData: any = [];
        columnList.forEach((element: any, index: any) => {
            let obj: any = {};
            obj['field'] = element.toLowerCase();
            if (de.length > 0) {
                const value = de[index];
                if (value) {
                    if (value.length > 0) {
                        if (value[0].text !== null) {
                            obj["de"] = value[0].text;
                        } else {
                            obj["de"] = element;
                        }
                    } else {
                        obj["de"] = element;
                    }
                }
            } else {
                obj["de"] = element;
            }
            if (en.length > 0) {
                const value = en[index];
                if (value) {
                    if (value.length > 0) {
                        if (value[0].text !== null) {
                            obj["en"] = value[0].text;
                        } else {
                            obj["en"] = element;
                        }
                    } else {
                        obj["en"] = element;
                    }
                }
            } else {
                obj["en"] = element;
            }

            translateData.push(obj);
        });

        setColumns([...translateData]);
    }, [en, de, columnList])

    useEffect(() => {
        let sort: any = [];
        columns.forEach((element: any) => {
            sort[element.field] = false;
        });

        setSortASC(sort);
    }, [columns])

    useEffect(() => {
        const gridColumns = columnList.map(() => {
            return 0;
        });
        setColumnWidthsObj(gridColumns.reduce((result: any, current: any, index: any) => {
            result[index] = current;
            return result;
        }, {}))
    }, [columnList])


    let PageSize = 20;
    const currentTableData = useMemo(() => {
        const firstPageIndex = (currentPage - 1) * PageSize;
        const lastPageIndex = firstPageIndex + PageSize;
        return totalColumnItems?.slice(firstPageIndex, lastPageIndex);
    }, [currentPage, totalColumnItems, PageSize]);

    const handlePageChange = (props: any) => {
        let page = parseInt(props);
        let itemscount = (page - 1) * PageSize;
        if (itemscount < totalColumnItems.length) {
            setCurrentPage(page);
        } else {
            setCurrentPage(currentPage + 1)
        }
    }

    useEffect(() => {
        setColumnItems([...currentTableData]);
    }, [currentTableData])

    useEffect(() => {
        setTotalColumnItems(totalData);
        // eslint-disable-next-line
    }, [totalData])

    useEffect(() => {
        if (sortAsc) {
            handleSort(currentsort, sortFlag);
        }
        // eslint-disable-next-line
    }, [sortAsc])

    useEffect(() => {
        setTimeout(() => {
            MenuComponent.reinitialization()
        }, 500)
    }, [currentPage])

    const handleSort = (field: string, flag: boolean) => {
        setCurrentSort(field);
        setSortFlag(flag);
        const items = [...totalData].sort(alphabetically(field, flag));

        let sort = sortAsc;
        sort[field] = !flag;
        setSortASC(sort);
        setTotalColumnItems([...items]);
    }

    const handleChangeWidth = (e: any, id: any, field: any) => {
        let currentwidth = columnWidthsObj[id] + e.width;
        if (columnWidthsObj[id] === 0) {
            currentwidth = minColumnWidthsObj[id] + e.width;
        }
        if (field !== "properties") {

            if (50 <= currentwidth) {
                const updateItems = {
                    ...columnWidthsObj,
                    [id]: currentwidth
                }
                setColumnWidthsObj(() => updateItems)
            } else {
                const updateItems = {
                    ...columnWidthsObj,
                    [id]: 50
                }
                setColumnWidthsObj(() => updateItems)
            }
        } else {
            if (minColumnWidthsObj[id] <= currentwidth) {
                const updateItems = {
                    ...columnWidthsObj,
                    [id]: currentwidth
                }
                setColumnWidthsObj(() => updateItems)
            } else {
                const updateItems = {
                    ...columnWidthsObj,
                    [id]: minColumnWidthsObj[id]
                }
                setColumnWidthsObj(() => updateItems)
            }

        }
    }

    useEffect(() => {
        if (columns) {
            const gridColumns = columns.map(() => {
                return 0;
            });
            setColumnWidthsObj(gridColumns.reduce((result: any, current: any, index: any) => {
                result[index] = current;
                return result;
            }, {}))
        }
        // eslint-disable-next-line 
    }, [columns])

    const handleChangeMinWidth = (width: any, id: any) => {
        const updateItems = {
            ...minColumnWidthsObj,
            [id]: width
        }
        minColumnWidthsObj = updateItems;
    }
    return (
        <div className="modal-dialog modal-dialog-centered mw-1200px">
            <div className="modal-content rounded bg-white" style={{ maxWidth: '1200px' }}>
                <div className="modal-header pb-0 border-0 justify-content-end">
                    <button
                        className="btn btn-sm btn-icon btn-active-color-primary"
                        onClick={handleClose}
                    >
                        <span className="svg-icon svg-icon-1">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)" fill="black" />
                                <rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)" fill="black" />
                            </svg>
                        </span>
                    </button>
                </div>
                <div className="modal-body scroll-y pt-0 pb-5" style={{paddingLeft: 30, paddingRight: 10}}>
                    <div className='w-100' >
                        <div className='pb-6'>
                            <div className='d-flex justify-content-between'>
                                <div className='d-flex'>
                                    <h2 className='fw-bolder align-items-center  text-dark'>
                                        {
                                            intl.formatMessage({ id: 'MENU.TEST.JOURNAL' })
                                        }
                                        &nbsp;
                                        {
                                            id
                                        }
                                    </h2>
                                </div>
                            </div>
                        </div>
                        <div className='w-100' style={{ overflow: 'auto', maxHeight: 'calc(100vh - 200px)' }}>
                            <table className='table table-row-dashed   table-row-gray-300 align-middle gs-0 gy-4'>
                                <thead style={{ position: 'sticky', top: 0, background: 'white' }}>
                                    <tr className='text-dark'>
                                        {
                                            //eslint-disable-next-line
                                            columns.map((item: any, index: number) => {
                                                if (definitions[index]) {
                                                    const definition = definitions[index].definition;
                                                    const xml = new XMLParser().parseFromString(definition);
                                                    const filter = xml.children.filter((item: any) => item.name === 'gridwidth')
                                                    let width = 150;
                                                    if (filter[0]) {
                                                        width = 1.5 * parseInt(filter[0].value);
                                                        if (width < 50) {
                                                            width = 50;
                                                        }
                                                    }
                                                    let Field = item[lang];
                                                    handleChangeMinWidth(width, index);
                                                    if (sortAsc) {
                                                        return (
                                                            <th
                                                                key={index}
                                                                title={item[lang]}
                                                                className='overflow-hidden text-left'
                                                                style={{ padding: '0px', cursor: 'pointer', position: 'relative', whiteSpace: 'nowrap' }}
                                                                onClick={() => handleSort(item['field'], sortAsc[item.field])}
                                                            >
                                                                <Resizable
                                                                    className="resize-content"
                                                                    style={{ padding: '10px' }}
                                                                    size={{ width: columnWidthsObj[index] > 0 ? columnWidthsObj[index] : width, height: '' }}
                                                                    enable={
                                                                        {
                                                                            "top": false,
                                                                            "right": true,
                                                                            "bottom": false,
                                                                            "left": false,
                                                                            "topRight": false,
                                                                            "bottomRight": false,
                                                                            "bottomLeft": false,
                                                                            "topLeft": false
                                                                        }
                                                                    }
                                                                    onResizeStop={(e, direction, ref, d) => {
                                                                        handleChangeWidth(d, index, item['field'])
                                                                    }}
                                                                >
                                                                    {
                                                                        currentsort === item['field'] ?
                                                                            <div className='d-flex justify-content-between text-primary' style={{ overflow: 'hidden' }}>
                                                                                {Field}
                                                                                {
                                                                                    sortAsc[item.field] ?
                                                                                        <KTSVG
                                                                                            className="svg-icon svg-icon-1 svg-icon-primary"
                                                                                            path="/media/icons/duotune/arrows/arr073.svg"
                                                                                        /> :
                                                                                        <KTSVG
                                                                                            className="svg-icon svg-icon-1 svg-icon-primary"
                                                                                            path="/media/icons/duotune/arrows/arr072.svg"
                                                                                        />
                                                                                }
                                                                            </div> :
                                                                            <div className='d-flex justify-content-between ' style={{ overflow: 'hidden' }}>
                                                                                {Field}
                                                                                {
                                                                                    sortAsc[item.field] ?
                                                                                        <KTSVG
                                                                                            className="svg-icon svg-icon-1 svg-icon-dark"
                                                                                            path="/media/icons/duotune/arrows/arr073.svg"
                                                                                        /> :
                                                                                        <KTSVG
                                                                                            className="svg-icon svg-icon-1 svg-icon-dark"
                                                                                            path="/media/icons/duotune/arrows/arr072.svg"
                                                                                        />
                                                                                }
                                                                            </div>
                                                                    }
                                                                </Resizable>
                                                            </th>
                                                        )
                                                    }
                                                }
                                            })
                                        }
                                        <th
                                            className='w-40px overflow-hidden text-left'
                                            style={{ padding: '0px', cursor: 'pointer', position: 'relative', whiteSpace: 'nowrap' }}
                                        ></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        columnItems?.length > 0 ?
                                            columnItems?.map((item: any, index: number) => {
                                                return (
                                                    <TabTableItem2
                                                        key={index}
                                                        indexing={index}
                                                        data={item}
                                                        options={options}
                                                        headers={columnList}
                                                        definitions={definitions}
                                                        columnNames={columns}
                                                    />
                                                );
                                            }) : (
                                                <NoDatas />
                                            )
                                    }
                                </tbody>
                            </table>
                        </div>

                        <Pagenation
                            currentPage={currentPage}
                            totalCount={totalColumnItems.length}
                            pageSize={PageSize}
                            onPageChange={handlePageChange}
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}

export { TestJournalModal };